import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { forgetPassword } from '../../../apiwrapper/user.ts';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ForgotpasswordTwo = () => {
  const translation = useSelector(state => state.root.translation);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const route = all_routes;

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!validateEmail(email)) {
      setError(translation['invalid_email_address']);
      return;
    }

    try {
      await forgetPassword(email);
      navigate(route.twostepverificationTwo);
      setMessage('Instructions to reset your password have been sent to your email.');
      // setTimeout(() => {
      //   navigate(route.signin);
      // }, 3000);
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
    setError('');
    setMessage('');
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
        <div className="login-img">
            <ImageWithBasePath
              src="assets/img/authentication/login02.png"
              alt="img"
            />
          </div>
          <div className="login-content">
            <form style={{ width: '80%' }} onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
                </Link>
                <div className="login-userheading">
                  <h3>{translation?.forgot_password}</h3>
                  <h4>
                  {translation?.forgot_password_message}
                  </h4>
                </div>
                <div className="form-login">
                  <label>{translation?.email_address}</label>
                  <div className="form-addons">
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={handleInputChange}
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/mail.svg"
                      alt="img"
                    />
                  </div>
                  {error && <p className="text-danger">{error}</p>}
                  {message && <p className="text-success">{message}</p>}
                </div>
                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                  {translation?.btn_confirm}
                  </button>
                </div>
                <div className="signinform text-center">
                  <h4>
                    {translation?.return_to}
                    <Link to={route.signin} className="hover-a">{translation?.sign_in}</Link>
                  </h4>
                </div>
                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>{translation?.copyright_message}</p>
                </div>
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ForgotpasswordTwo;
